import debug from 'debug'

const baseLogger = debug('publish')

export const getDebugLogger = (module: string): typeof baseLogger =>
  baseLogger.extend(module)
